'use client';
import { useTypedTranslation } from '@/hooks/useTypedTranslation';
import styles from './MerchantsTestimonial.module.css';
import Image from 'next/image';

export default function MerchantsTestimonial() {
  const { t } = useTypedTranslation();

  return (
    <section className={styles.testimonialSection}>
      <div className={styles.container}>
        <div className={styles.testimonialContainer}>
          <div className={styles.quoteContainer}>
            <div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="72"
                height="72"
                viewBox="0 0 72 72"
                fill="none"
                className={styles.quoteIcon}
              >
                <g id="bxs:quote-left">
                  <path
                    id="Vector"
                    d="M11.0733 18.876C15.2823 14.313 21.6513 12 30.0003 12H33.0003V20.457L30.5883 20.94C26.4783 21.762 23.6193 23.379 22.0893 25.752C21.2907 27.0303 20.8379 28.4941 20.7753 30H30.0003C30.796 30 31.559 30.3161 32.1216 30.8787C32.6842 31.4413 33.0003 32.2044 33.0003 33V54C33.0003 57.309 30.3093 60 27.0003 60H9.00031C8.20466 60 7.4416 59.6839 6.87899 59.1213C6.31638 58.5587 6.00031 57.7957 6.00031 57V42L6.00931 33.243C5.98231 32.91 5.41231 25.02 11.0733 18.876ZM60.0003 60H42.0003C41.2047 60 40.4416 59.6839 39.879 59.1213C39.3164 58.5587 39.0003 57.7957 39.0003 57V42L39.0093 33.243C38.9823 32.91 38.4123 25.02 44.0733 18.876C48.2823 14.313 54.6513 12 63.0003 12H66.0003V20.457L63.5883 20.94C59.4783 21.762 56.6193 23.379 55.0893 25.752C54.2907 27.0303 53.8379 28.4941 53.7753 30H63.0003C63.796 30 64.559 30.3161 65.1216 30.8787C65.6842 31.4413 66.0003 32.2044 66.0003 33V54C66.0003 57.309 63.3093 60 60.0003 60Z"
                    fill="#F71963"
                  />
                </g>
              </svg>
            </div>
            <p className={styles.testimonialQuote}>{t('merchants.testimonial.quote')}</p>
          </div>
          <div className={styles.testimonialAuthor}>
            <div className={styles.testimonialImage}>
              <Image
                src="/images/testimonials_img_merchant_desktop.webp"
                alt={t('merchants.testimonial.name')}
                width={180}
                height={180}
                className={styles.authorImage}
              />
            </div>
            <div className={styles.authorInfo}>
              <h4 className={styles.authorName}>{t('merchants.testimonial.name')}</h4>
              <p className={styles.authorRole}>{t('merchants.testimonial.role')}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
